/* lua.js generated code 0.3.0 */
 //-----------------------------------------------------------------------
//  Class include: Events, Event, DisplayEvents, DisplayEvent, EventDispatcher, GlobalEventDispatcher
//-----------------------------------------------------------------------
var debugEvent = false
// Events ---------------------------------------------------------
// common event name we used in library.
Events = table(
    [1, "kComplete", "complete"],
    [1, "kCancel", "cancel"],
    [1, "kConnect", "connect"],
    [1, "kConfirm", "confirm"],
    [1, "kError", "error"],
    [1, "kStart", "start"],
    [1, "kClose", "close"],
    [1, "kAddToStage", "addToStage"],
    [1, "kRemoveFromStage", "removeFromStage"],
    [1, "kDispose", "disposing"],
    [1, "kProgress", "progress"]
)
SceneEvents = table([1, "kEnterForeground", "enterForeground"], [1, "kEnterBackground", "enterBackground"])
let Event = xClass("_Event")
Event.prototype.ctor = function (name, data, target) {
    var self = this
    self.name = name
    self.data = data
    self.target = target
    self.code = 0
    self.context = null
}
Event.prototype.dispose = function () {
    var self = this
    self.name = null
    self.target = null
    self.data = null
    self.context = null
}
Event.prototype.toString = function () {
    var self = this
    // WARN: maybe multi result
    return string.format("Event [%s]", self.name && self.name || "nil")
}
// DisplayEvents ---------------------------------------------------------
DisplayEvents = table(
    [1, "kTouchBegin", "touchBegin"],
    [1, "kTouchEnd", "touchEnd"],
    [1, "kTouchMove", "touchMove"],
    [1, "kTouchTap", "touchTap"],
    [1, "kTouchItem", "touchItem"],
    [1, "kTouchMoveIn", "touchMoveIn"],
    [1, "kTouchMoveOut", "touchMoveOut"],
    [1, "kTouchBeginOutSide", "touchBeginoutSide"]
)
// DisplayEvent ---------------------------------------------------------
DisplayEvent = xClass("DisplayEvent", Event)
DisplayEvent.prototype.ctor = function (name, target, globalPosition, id) {
    var self = this
    self.class = DisplayEvent
    self.name = name
    self.data = null
    self.target = target
    self.globalPosition = globalPosition
    self.propagation = true
    self.id = id
}
//Prevents processing of any event listeners in nodes subsequent to the current node in the event flow.
DisplayEvent.prototype.stopPropagation = function () {
    var self = this
    self.propagation = false
}
DisplayEvent.prototype.toString = function () {
    var self = this
    // WARN: maybe multi result
    return string.format("DisplayEvent [%s]", self.name && self.name || "nil")
}
DisplayEvent.prototype.clone = function () {
    var self = this
    var evt = DisplayEvent.new(self.name, self.target)
    return evt
}
// EventDispatcher ---------------------------------------------------------
// members
EventDispatcher = xClass("EventDispatcher")
// initialize
EventDispatcher.prototype.ctor = function () {
    var self = this
    self.class = EventDispatcher
    self.receivers = {} // of <{function,function...}>
}
// public methods
EventDispatcher.prototype.toString = function () {
    var self = this
    return "EventDispatcher"
}
//Dispatches an event into the event flow.
EventDispatcher.prototype.dispatchEvent = function (event) {
    var self = this
    if (debugEvent) {
        cc.log("EventDispatcher:dispatchEvent", event.name, event.data, event.target)
    }
    var eventName = event.name
    if (!eventName) {
        return 
    }
    var list = self.receivers[eventName] //of <function>
    if ((!list) || type(list) !== "table") {
        return 
    }
    // by default, iterator throw a table is a non-atom operation,
    // to avoid modify table while iteration (by callback), we need a atom-table or just clone the old one as I did.
    for (var k = 1, v = list[1]; v; k++, v = list[k]) {
        event.context = null
        if (v[1]) {
            event.context = v[1]
        }
        v[0](event)
        event.context = null
    }
}
//Checks whether the EventDispatcher object has any listeners registered for a specific type of event.
EventDispatcher.prototype.hasEventListener = function (eventName, listener) {
    var self = this
    if (!eventName) {
        return [false]
    }
    if (self.receivers) {
        var list = self.receivers[eventName] //of <function>
        if (!list) {
            return [false]
        }
        for (var i = 1, v = list[1]; v; i++, v = list[i]) {
            if (v[0] === listener) {
                return [true, i]
            }
        }
    }
    return [false]
}
//Checks whether the EventDispatcher object has any listeners registered for a specific type of event.
EventDispatcher.prototype.hasEventListenerByName = function (eventName) {
    var self = this
    if (!eventName) {
        return false
    }
    if (self.receivers) {
        var list = self.receivers[eventName] //of <function>
        if (list && table.getn(list) > 0) {
            return true
        }
    }
    return false
}
//Registers an event listener object with an EventDispatcher object so that the listener receives notification of an event.
EventDispatcher.prototype.addEventListener = function (eventName, listener, context) {
    var self = this
    assert(eventName, "EventDispatcher:addEventListener : parameter event name is nil !")
    assert(listener, "EventDispatcher:addEventListener : parameter listener is nil !")
    if (debugEvent) {
        cc.log("EventDispatcher:addEventListener", eventName, listener)
    }
    if ((!eventName) || (!listener) || (!self.receivers)) {
        assert(false)
        return 
    }
    var bool = self.hasEventListener(eventName, listener)[0]
    if (bool) {
        if (debugEvent) {
            cc.log("EventDispatcher:addEventListener event already add")
        }
    } else {
        var list = self.receivers[eventName] //of <function>
        if ((!list) || type(list) !== "table") {
            list = sTable()
            self.receivers[eventName] = list
        }
        table.insert(list, [listener, context])
    }
    return self
}
//Removes a listener from the EventDispatcher object.
EventDispatcher.prototype.removeEventListener = function (eventName, listener) {
    var self = this
    assert(eventName)
    assert(listener)
    if (debugEvent) {
        cc.log("EventDispatcher:removeEventListener", eventName, listener)
    }
    if ((!eventName) || (!listener) || (!self.receivers)) {
        assert(false)
        return 
    }
    var [bool, i] = self.hasEventListener(eventName, listener)
    //assert(bool)
    if (bool) {
        var list = self.receivers[eventName] //of <function>
        table.remove(list, i)
    }
}
//Removes a listener from the EventDispatcher object.
EventDispatcher.prototype.removeEventListenerByName = function (eventName) {
    var self = this
    if (debugEvent) {
        cc.log("EventDispatcher:removeEventListenerByName", eventName)
    }
    if ((!eventName) || (!self.receivers)) {
        return 
    }
    self.receivers[eventName] = null
}
EventDispatcher.prototype.removeAllEventListeners = function () {
    var self = this
    var list = self.receivers
    for (var k in list) {
        var v = list[k]
        if ($null(v)) continue
        self.receivers[k] = null
    }
}
//atlis
EventDispatcher.prototype.dp = EventDispatcher.prototype.dispatchEvent
EventDispatcher.prototype.he = EventDispatcher.prototype.hasEventListener
EventDispatcher.prototype.hn = EventDispatcher.prototype.hasEventListenerByName
EventDispatcher.prototype.ad = EventDispatcher.prototype.addEventListener
EventDispatcher.prototype.rm = EventDispatcher.prototype.removeEventListener
EventDispatcher.prototype.rma = EventDispatcher.prototype.removeAllEventListeners
var instance = null
GlobalEventDispatcher = xClass("GlobalEventDispatcher", EventDispatcher)
GlobalEventDispatcher.getInstance = function () {
    var self = this
    if (instance == null) {
        instance = GlobalEventDispatcher.new()
    }
    return instance
}
GlobalEventDispatcher.prototype.reset = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    instance = null
}

kGlobalEvents = table.const(table(
    [1, "kSyncFinished", "global.event.sync.done"],
    [1, "kUserLogin", "global.event.login.done"],
    [1, "kProfileUpdate", "global.event.profile.change"],
    [1, "kAcceptFriends", "global.event.messagecenter.friends.accept"],
    [1, "kMessageCenterUpdate", "global.event.messagecenter.update"],
    [1, "kGamecenterLogin", "global.event.gc.login"],
    [1, "kMaintenanceChange", "global.event.maintenance"],
    [1, "kConsumeComplete", "global.event.consume.complete"],
    [1, "kDefaultPaymentTypeAutoChange", "global.event.defaultpayment.auto.change"],
    [1, "kEnterForeground", "global.event.enter.foreground"],
    [1, "kEnterBackground", "global.event.enter.background"],
    [1, "kActivityLevelShare", "global.event.activity.level.share"],
    [1, "kShowReplayRecordPreview", "global.event.replay.preview.show"],
    [1, "kAliSignAndPayReturn", "global.event.ali.sign.pay.return"],
    [1, "kWechatSignReturn", "global.event.wechat.sign.return"],
    [1, "kLeaveStarGroup", "global.event.leave.star.group"],
    [1, "kLeaveShake", "global.event.leave.star.group"],
    [1, "kRankDataUpdate", "global.event.home.level.node"],
    [1, "kWeekGameWeekOrDayEnd", "global.event.weekgame.weekordayend"],
    [1, "kGachaReward", "global.event.gacha.reward"],
    [1, "kOneSceneEnter", "global.event.one.scene.enter"],  // 某个BaseScene 触发了 onEnter
    [1, "kOneOrderGenerate", "global.event.one.order.generate"],    // 生成了一张订单
    [1, "kWelfareCenterAction", "global.event.welfare.center"],    // 增删改 福利中心的活动信息
    [1, "kWelfareCenterClick", "global.event.welfare.center.click"],    // 福利中心点击banner
    [1, "kWelfareCenterPanel", "global.event.welfare.center.panel"],    // 福利中心打开相应面板面板
    [1, "kGameResLoadProgress", "global.event.game.res.load.progress"],  //加载资源
    [1, "kFishingGetBook", "global.event.fishing.book"],    // 钓鱼大赛通过分享链接获得新鱼图鉴
    [1, "kMedalRankOpen", "global.event.medal.rank.open"],    // 勋章排行榜打开 / 关闭
))


module.exports = {
    Event: Event
}